// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const addPart = () => ({
    type: actions.CREATE_CLAIM_INCENTIVE_PART
});

export const deletePart = index => ({
    index,
    type: actions.DELETE_CLAIM_INCENTIVE_PART
});

export const changePartProperty = (index, data, property) => ({
    data,
    index,
    property,
    type: actions.UPDATE_CLAIM_INCENTIVE_PART_FIELDS
});

export const changePartsUnit = (index, unit, unitCollection) => ({
    data: findMatchingKey(unit, unitCollection),
    index,
    type: actions.UPDATE_CLAIM_INCENTIVE_PART_UNIT
});



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/parts.js